import React from "react";
import "./InfoDetails.css";
import { Link } from "react-router-dom";

export default function InfoCost() {
  return (
    <div className="info-detail">

      <div className="info-hero costs">
        <h2>Módulo de consumos y costos</h2>
        <p>
          Centraliza toda la información de proveedores, facturas y dashboards
          relacionados con costos y sostenibilidad. Diseñado para simplificar la
          gestión financiera y energética de la empresa.
        </p>
      </div>

      <section className="info-section">
        <h3>Gestión de proveedores y facturas</h3>
        <ul>
          <li>Asignar proveedores a sucursales de manera organizada.</li>
          <li>Definir conceptos de facturas personalizados.</li>
          <li>Formulario intuitivo para carga de facturas.</li>
        </ul>
      </section>

      <section className="info-section alt">
        <h3>Dashboards disponibles</h3>
        <ul>
          <li>
            <b>Consumos</b>: monitoreo detallado de energía y recursos.
          </li>
          <li>
            <b>Costos</b>: seguimiento de gastos asociados.
          </li>
          <li>
            <b>Sostenibilidad</b>: métricas de impacto ambiental.
          </li>
          <li>
            <b>Comparativas anuales</b>: evolución año a año.
          </li>
        </ul>
      </section>

      <section className="info-section">
        <h3>Beneficios clave</h3>
        <ul>
          <li>Visión integral de costos y consumos en un solo lugar.</li>
          <li>Mejor control de proveedores y contratos.</li>
          <li>
            Datos listos para análisis y toma de decisiones estratégicas.
          </li>
        </ul>
      </section>

        <section className="info-flow">
        <h3>Flujo de gestión de consumos y costos</h3>
        <ol>
            <li>Un usuario Admin-master o Editor <b>asigna proveedores</b> a cada sucursal.</li>
            <li>Define los <b>conceptos de facturación</b> (ej. energía consumida, agua consumida, gas consumido, impuestos).</li>
            <li>Completa el <b>formulario de carga</b> de facturas de cada proveedor.</li>
            <li>Los datos se consolidan en <b>dashboards</b> de consumos, costos y sostenibilidad.</li>
            <li>El usuario analiza comparativas y evolución de los costos.</li>
        </ol>
        </section>

      <div className="info-cta">
        <h4>¿Listo para optimizar tus costos?</h4>
        <Link to="/info" className="cta-button">
          Explorar más módulos
        </Link>
      </div>
    </div>
  );
}
